import React from 'react';

const AlertOrange = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    className,
    style: { ...style, overflow: "visible" },
    width: "28",
    height: "29",
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M2.90254 25.4375C2.68865 25.4375 2.49421 25.3842 2.31921 25.2777C2.14421 25.1711 2.0081 25.0299 1.91088 24.8542C1.81365 24.6784 1.76038 24.4886 1.75104 24.2848C1.74171 24.0811 1.79499 23.8819 1.91088 23.6875L12.7025 5.02083C12.8192 4.82639 12.9701 4.68056 13.1552 4.58333C13.3403 4.48611 13.5297 4.4375 13.7234 4.4375C13.917 4.4375 14.1068 4.48611 14.2927 4.58333C14.4786 4.68056 14.6291 4.82639 14.7442 5.02083L25.5359 23.6875C25.6525 23.8819 25.7062 24.0814 25.6969 24.286C25.6875 24.4906 25.6339 24.6799 25.5359 24.8542C25.4379 25.0284 25.3018 25.1696 25.1275 25.2777C24.9533 25.3858 24.7589 25.4391 24.5442 25.4375H2.90254ZM13.7234 21.9375C14.0539 21.9375 14.3312 21.8255 14.5552 21.6015C14.7792 21.3775 14.8908 21.1006 14.89 20.7708C14.8893 20.4411 14.7773 20.1642 14.554 19.9402C14.3308 19.7162 14.0539 19.6042 13.7234 19.6042C13.3928 19.6042 13.1159 19.7162 12.8927 19.9402C12.6695 20.1642 12.5575 20.4411 12.5567 20.7708C12.5559 21.1006 12.6679 21.3779 12.8927 21.6027C13.1175 21.8274 13.3944 21.9391 13.7234 21.9375ZM13.7234 18.4375C14.0539 18.4375 14.3312 18.3255 14.5552 18.1015C14.7792 17.8775 14.8908 17.6006 14.89 17.2708V13.7708C14.89 13.4403 14.778 13.1634 14.554 12.9402C14.33 12.7169 14.0532 12.6049 13.7234 12.6042C13.3936 12.6034 13.1167 12.7154 12.8927 12.9402C12.6687 13.1649 12.5567 13.4418 12.5567 13.7708V17.2708C12.5567 17.6014 12.6687 17.8787 12.8927 18.1027C13.1167 18.3267 13.3936 18.4383 13.7234 18.4375Z",
      fill: "#FF7400"
    }
  )
);
AlertOrange.displayName = "Icons.AlertOrange";

export { AlertOrange };
//# sourceMappingURL=AlertOrange.js.map
